export default {
    'it-IT': {
        noReviews:
            'Non sono state fatte ancora recensioni sul prodotto. Fai tu la prima recensione!',
        writeAReview: 'Scrivi una recensione',
        allReviews: 'Tutte le recensioni',
        ratingLabel: 'Giudizio complessivo',
        qualityPriceRatio: 'Rapporto qualità/prezzo',
        reportAbuse: 'Segnala questa recensione',
        abuseKind: 'Per quale motivo vuoi segnalare questa recensione?',
        reviewsTitle: 'Recensioni per {title}',
        mustBeLoggedIn:
            'Per potere scrivere una recensione è necessario essere loggati.',
        clickToLogIn: 'Clicca qui per loggarti.',
        goToProduct: 'Vai al prodotto',
        sortBy: 'Ordina per:',
        sortByBestRating: 'Miglior voto',
        sortByBestRatingTitle: 'Ordina per le recensioni con il miglior voto',
        sortByMostRecent: 'Più recenti',
        sortByMostRecentTitle: 'Ordina per le recensioni più recenti',
        sortByMostUseful: 'Più utili',
        sortByMostUsefulTitle: 'Ordina per le recensioni più utili',
        sortByWorstRating: 'Peggior voto',
        sortByWorstRatingTitle: 'Ordina per le recensioni con il peggior voto',
        writeAReviewForProduct:
            'Scrivi la tua recensione per <a class="link" href={slug}>{title}</a>',
        sendReview: 'Invia la recensione',
        readReviews: 'Leggi le recensioni',
    },
    'fr-FR': {
        noReviews:
            "Aucun commentaire n'a encore été écrit pour ce produit. Soyez le premier à en poster un!",
        writeAReview: 'Laisser un commentaire',
        allReviews: 'Lire tous les commentaires',
        ratingLabel: 'Avis global',
        qualityPriceRatio: 'Rapport qualité/prix',
        reportAbuse: 'Signaler cet avis',
        abuseKind: 'Pour quelle raison souhaitez-vous signaler cet avis?',
        reviewsTitle: 'Commentaires pour {title}',
        mustBeLoggedIn:
            'Vous devez être connecté(e) pour pouvoir laisser un commentaire.',
        clickToLogIn: 'Cliquer ici pour vous connecter.',
        goToProduct: 'Aller au produit',
        sortBy: 'Trier par:',
        sortByBestRating: 'Meilleure note',
        sortByBestRatingTitle:
            'Trier les commentaires par note (la plus haute)',
        sortByMostRecent: 'Plus récents',
        sortByMostRecentTitle: 'Trier les commentaires les plus récents',
        sortByMostUseful: 'Plus utiles',
        sortByMostUsefulTitle: 'Trier les commentaires les plus utiles',
        sortByWorstRating: 'Note la plus basse',
        sortByWorstRatingTitle:
            'Trier les commentaires par note (la plus basse)',
        writeAReviewForProduct:
            'Laisser un commentaire <a class="link" href={slug}>{title}</a>',
        sendReview: 'Envoyer mon commentaire',
        readReviews: 'Voir les commentaires',
    },
    'es-ES': {
        noReviews:
            'No se han hecho comentarios de este artículo. ¡Sé el primero en comentar!',
        writeAReview: 'Escribe un comentario',
        allReviews: 'Leer todos los comentarios',
        ratingLabel: 'Evaluación global',
        qualityPriceRatio: 'Relación calidad/precio',
        reportAbuse: 'Denunciar este comentario',
        abuseKind: '¿Por qué quieres denunciar este comentario?',
        reviewsTitle: 'Comentarios para {title}',
        mustBeLoggedIn:
            'Para dejar un comentario es necesario estar registrado.',
        clickToLogIn: 'Haz clic aquí para iniciar sesión.',
        goToProduct: 'Ir al producto',
        sortBy: 'Ordenar por:',
        sortByBestRating: 'Mejor voto',
        sortByBestRatingTitle: 'Ordenar comentarios por el mejor voto',
        sortByMostRecent: 'Más recientes',
        sortByMostRecentTitle: 'Ordenar por comentarios más recientes',
        sortByMostUseful: 'Más útil',
        sortByMostUsefulTitle: 'Ordenar por comentarios más útiles',
        sortByWorstRating: 'Peor voto',
        sortByWorstRatingTitle: 'Ordenar por comentarios con peor voto',
        writeAReviewForProduct:
            'Escribe un comentario para <a class="link" href={slug}>{title}</a>',
        sendReview: 'Enviar comentario',
        readReviews: 'Leer los comentarios',
    },
    'en-GB': {
        noReviews:
            'There are not any reviews written about this product. Be the first!',
        writeAReview: 'Write a review',
        allReviews: 'Read all reviews',
        ratingLabel: 'Overall rating',
        qualityPriceRatio: 'Quality/price comparison',
        reportAbuse: 'Report this review',
        abuseKind: 'Why do you want to report this review?',
        reviewsTitle: 'Reviews for {title}',
        mustBeLoggedIn:
            'To be able to write a review you need to be logged in.',
        clickToLogIn: 'Click here to login.',
        goToProduct: 'Go to product',
        sortBy: 'Sort by:',
        sortByBestRating: 'Best rating',
        sortByBestRatingTitle: 'Sort by reviews with best rating',
        sortByMostRecent: 'Recent reviews',
        sortByMostRecentTitle: 'Sort by recent reviews',
        sortByMostUseful: 'Most helpful',
        sortByMostUsefulTitle: 'Sort by helpful review',
        sortByWorstRating: 'Worst reviews',
        sortByWorstRatingTitle: 'Sort by reviews with worst rating',
        writeAReviewForProduct:
            'Write your review for <a class="link" href={slug}>{title}</a>',
        sendReview: 'Send review',
        readReviews: 'View reviews',
    },
    'en-US': {
        noReviews:
            'There are not any reviews written about this product. Be the first!',
        writeAReview: 'Write a review',
        allReviews: 'Read all reviews',
        ratingLabel: 'Overall rating',
        qualityPriceRatio: 'Quality/price comparison',
        reportAbuse: 'Report this review',
        abuseKind: 'Why do you want to report this review?',
        reviewsTitle: 'Reviews for {title}',
        mustBeLoggedIn:
            'To be able to write a review you need to be logged in.',
        clickToLogIn: 'Click here to login.',
        goToProduct: 'Go to product',
        sortBy: 'Sort by:',
        sortByBestRating: 'Best rating',
        sortByBestRatingTitle: 'Sort by reviews with best rating',
        sortByMostRecent: 'Recent reviews',
        sortByMostRecentTitle: 'Sort by recent reviews',
        sortByMostUseful: 'Most helpful',
        sortByMostUsefulTitle: 'Sort by helpful review',
        sortByWorstRating: 'Worst reviews',
        sortByWorstRatingTitle: 'Sort by reviews with worst rating',
        writeAReviewForProduct:
            'Write your review for <a class="link" href={slug}>{title}</a>',
        sendReview: 'Send review',
        readReviews: 'View reviews',
    },
    'de-DE': {
        noReviews:
            'Dieses Produkt hat noch keine Rezension. Schreiben Sie die erste!',
        writeAReview: 'Schreiben Sie eine Rezension',
        allReviews: 'Alle Rezensionen lesen',
        ratingLabel: 'Gesamtbewertung',
        qualityPriceRatio: 'Preis-Leistungsverhältnis',
        reportAbuse: 'Diese Bewertung melden',
        abuseKind: 'Warum möchten Sie diese Bewertung melden?',
        reviewsTitle: 'Rezensionen für {title}',
        mustBeLoggedIn:
            'Um eine Rezension schreiben zu können, muss man eingeloggt sein.',
        clickToLogIn: 'Klicken Sie hier, um sich anzumelden.',
        goToProduct: 'Zum Produkt',
        sortBy: 'Filtern nach:',
        sortByBestRating: 'Beste Bewertung',
        sortByBestRatingTitle: 'Nach den besten Bewertungen filtern',
        sortByMostRecent: 'Jüngstere',
        sortByMostRecentTitle: 'Nach den jüngsteren Rezensionen filtern',
        sortByMostUseful: 'Nützlichere',
        sortByMostUsefulTitle: 'Nach den nützlichere Rezensionen filtern',
        sortByWorstRating: 'Schlechste Bewertung',
        sortByWorstRatingTitle: 'Nach den schlechsten Bewertungen filtern',
        writeAReviewForProduct:
            'Schreiben Sie Ihre Rezension für <a class="link" href={slug}>{title}</a>',
        sendReview: 'Rezension schicken',
        readReviews: 'Rezensionen lesen',
    },
    'en-AU': {
        noReviews:
            'There are not any reviews written about this product. Be the first!',
        writeAReview: 'Write a review',
        allReviews: 'Read all reviews',
        ratingLabel: 'Overall rating',
        qualityPriceRatio: 'Quality/price comparison',
        reportAbuse: 'Report this review',
        abuseKind: 'Why do you want to report this review?',
        reviewsTitle: 'Reviews for {title}',
        mustBeLoggedIn:
            'To be able to write a review you need to be logged in.',
        clickToLogIn: 'Click here to login.',
        goToProduct: 'Go to product',
        sortBy: 'Sort by:',
        sortByBestRating: 'Best rating',
        sortByBestRatingTitle: 'Sort by reviews with best rating',
        sortByMostRecent: 'Recent reviews',
        sortByMostRecentTitle: 'Sort by recent reviews',
        sortByMostUseful: 'Most helpful',
        sortByMostUsefulTitle: 'Sort by helpful review',
        sortByWorstRating: 'Worst reviews',
        sortByWorstRatingTitle: 'Sort by reviews with worst rating',
        writeAReviewForProduct:
            'Write your review for <a class="link" href={slug}>{title}</a>',
        sendReview: 'Send review',
        readReviews: 'View reviews',
    },
};
